var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_370_24873",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_370_24873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 21V11.625L2.2 13L1 11.4L12 3L23 11.4L21.8 12.975L20 11.625V21H4ZM8 15C7.71667 15 7.47917 14.9042 7.2875 14.7125C7.09583 14.5208 7 14.2833 7 14C7 13.7167 7.09583 13.4792 7.2875 13.2875C7.47917 13.0958 7.71667 13 8 13C8.28333 13 8.52083 13.0958 8.7125 13.2875C8.90417 13.4792 9 13.7167 9 14C9 14.2833 8.90417 14.5208 8.7125 14.7125C8.52083 14.9042 8.28333 15 8 15ZM12 15C11.7167 15 11.4792 14.9042 11.2875 14.7125C11.0958 14.5208 11 14.2833 11 14C11 13.7167 11.0958 13.4792 11.2875 13.2875C11.4792 13.0958 11.7167 13 12 13C12.2833 13 12.5208 13.0958 12.7125 13.2875C12.9042 13.4792 13 13.7167 13 14C13 14.2833 12.9042 14.5208 12.7125 14.7125C12.5208 14.9042 12.2833 15 12 15ZM16 15C15.7167 15 15.4792 14.9042 15.2875 14.7125C15.0958 14.5208 15 14.2833 15 14C15 13.7167 15.0958 13.4792 15.2875 13.2875C15.4792 13.0958 15.7167 13 16 13C16.2833 13 16.5208 13.0958 16.7125 13.2875C16.9042 13.4792 17 13.7167 17 14C17 14.2833 16.9042 14.5208 16.7125 14.7125C16.5208 14.9042 16.2833 15 16 15Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.acf061b41e4edfa2ff48973444b9166b.svg";
export { ForwardRef as ReactComponent };